import { useSyncExternalStore } from 'react';

// Lucky Six runs in an iframe and reports its ticket to us (postMessage), so
// the modern bottom bar can show it next to the sports ticket and open it.

export type Lucky6Slip = {
  count: number;
  stake: number;
  maxWin: number;
  currency: string;
};

const empty: Lucky6Slip = { count: 0, stake: 0, maxWin: 0, currency: '' };
let slip: Lucky6Slip = empty;
let frame: Window | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function setLucky6Frame(w: Window | null) {
  frame = w;
  if (!w) {
    slip = empty;
    emit();
  }
}

export function setLucky6Slip(s: Lucky6Slip) {
  slip = s;
  emit();
}

export function openLucky6Slip() {
  frame?.postMessage({ type: 'lucky6:open-slip' }, '*');
}

export function useLucky6Slip(): Lucky6Slip {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => slip
  );
}
